import { HttpHandler } from 'msw'

import { contactConsumer } from './contactConsumer'
import { getAllSales } from './getAllSales'
import { getReceipt } from './getReceipt'
import { getSale } from './getSale'
import { refuseDispute } from './refuseDispute'

export const sales: HttpHandler[] = [
    contactConsumer,
    getAllSales,
    getReceipt,
    getSale,
    refuseDispute,
]
